/*!
 *  (c)(r) 2008-2025 IT-Service Robert Frunzke
 */

import { htmlspecialchars, MPlugins, mj } from 'js/entry/util.js';
import { $ } from 'js/entry/base.js';
import { mjt } from 'js/entry/i18ntexts.js';

import { Lightbox } from 'js/entry/media.js';


/**
 * add votings-related status info to "media send" views
 */
MPlugins.register( [$,mj], 'ui-votings-send-dialog-hooks', function($,mj) {

	return {
		type: 'MediaSendView',

		/** ============================ called while selecting a lightbox (msslb-form) ================================================= **/

		setupSendSelectView: function( list_item, $link_parent_elem, on_click ) {
			//console.log({plugin:'ui-votings-send-dialog-hooks',fn:'setupSendSelectView', list_item, $link_parent_elem, on_click });

			if( list_item.x_name ) {
				var label;
				if( list_item.x_name==='ui_votings' ) label = mjt('msslb-already-associated-to-votings');
				else label = mjt('msslb-already-associated-otherwise');

				$('<span class="msslb-start-voting disabled" tabindex="-1">'+label+'</span>')
					.appendTo($link_parent_elem);

			} else {
				$('<span class="msslb-start-voting emph-link" tabindex="0">'+mjt('msslb-start-voting')+'</span>')
					.on('click',on_click)
					.appendTo($link_parent_elem);
			}
		},



		/** ============================ called in actual send-as-lightbox dialog ================================================= **/

		handleSendInfoResponse: function( j, pluginContext ) {
			//console.log({plugin:'ui-votings-send-dialog-hooks',fn:'handleSendInfoResponse',j, pluginContext});

			j.send_to_guest_enabled = false;
		},

		preSetupSendViewData: function( $list_elem, pluginContext ) {
			//console.log({plugin:'ui-votings-send-dialog-hooks',fn:'preSetupSendViewData',$list_elem,pluginContext});

		},

		getMailSubjectText( sender, rcpt, pluginContext ) {
			return pluginContext.subject = mjt('votings-ms-mail-subject-default','!').replace('%1',sender['short-display-name']);
		},

		postProcessAvailableRcptsList( sender, rcpt_list, pluginContext ) {

			// eslint-disable-next-line
			//console.log({ sender, rcpt_list, pluginContext })

			// make sure, users can not select theirselves for  ..
			for( var i=0; i<rcpt_list.length; ++i ) {
				if( rcpt_list[i].id == mj.user_id ) rcpt_list[i].disabled = true;
			}
			pluginContext.rcpt_list = rcpt_list;
		},




		setupSendView: function( $container_elem, $context_elem, sender, pluginContext ) {
			//console.log({plugin:'ui-votings-send-dialog-hooks',fn:'setupSendView',$container_elem,$context_elem,sender,pluginContext});

			var ms_mail_subject_elem = $container_elem.find('#ms_mail_subject');
			//console.log({'ms_mail_subject_elem.value':ms_mail_subject_elem.val()});
			ms_mail_subject_elem.val( mjt('votings-ms-mail-subject-default','!').replace('%1',sender['short-display-name']) );

			var originating_lb_id = pluginContext.originating_lb_id || 0;
			var originating_lb_title = pluginContext.originating_lb_title || 'unknown';

			$(   '<span class="label">'+mjt('msslb-voting-info')+'</span>'
				+'<span class="lightbox-name">'+htmlspecialchars(originating_lb_title,false,true)+' (ID '+originating_lb_id+')'+'</span>'
				+'<span class="help">'+mjt('msslb-voting-info-help')+'</span>')
				.appendTo($context_elem);
			//$context_elem.attr('title',mjt('msslb-voting-info-help')).show();
			$context_elem.show();

			$('#ms-c-plugin-data',$container_elem)
				.find('h2').text(mjt('msslb-voting-data-title','!')).end()
				.find('.hint').text(mjt('msslb-voting-data-info','!'));

			var $pluginDataElem = $('#ms-plugin-data',$container_elem)
				.empty()
				.html(
					'<span class="votings-expiry-dt-wdg"></span>'
					+'<br><br>'
				);

			var min_date = +1; // => +1 == tomorrow
			$pluginDataElem.find('.votings-expiry-dt-wdg')
				.mjWidget( {
					type: 'datetime',
					name: 'ext_data[ui_votings][expiry_dt]',
					value: '',
					minDate: min_date
				} );


			$('button[type="submit"] .label',$container_elem).text(mjt('msslb-voting-submit','!'));
		},

		beforeSubmit: function( $container_elem, $form_fields_1, plugins_extra_postdata, pluginContext ) {

			// // eslint-disable-next-line
			// console.log({plugin:'ui-votings-send-dialog-hooks',fn:'beforeSubmit',$container_elem,$form_fields_1,pluginContext});

			if( plugins_extra_postdata.hasOwnProperty('associated_exts') ) plugins_extra_postdata.associated_exts.push('ui_votings');
			else plugins_extra_postdata.associated_exts = ['ui_votings'];

			var expiry_dt = $container_elem.find('.votings-expiry-dt-wdg').mjWidget('get');

			if( !plugins_extra_postdata.hasOwnProperty('ext_data') ) plugins_extra_postdata.ext_data = {};
			plugins_extra_postdata.ext_data.ui_votings = {
				list_id: pluginContext.originating_lb_id,
				title: pluginContext.originating_lb_title || 'unknown',
				expiry_dt: expiry_dt
			};
		},

		afterSubmit: function( response_data, pluginContext ) {

			// // eslint-disable-next-line
			// console.log({plugin:'ui-votings-send-dialog-hooks',fn:'afterSubmit',response_data,pluginContext});

			Lightbox.triggerGo(pluginContext.originating_lb_id,'force');
		},

	};
} );

